import { Component, Inject } from '@angular/core';
import { VERSION } from '@ideapa/app-common';

@Component({
  standalone: false,
  selector: 'ideapa-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  constructor(@Inject(VERSION) public version: string) {}
}
